import { getLangeKey } from '@/data/i18n/translateLang'

interface IPropList {
  // 字段名、插槽名
  prop: string
  // 表头插槽名
  headSlotName: string
  // 宽度
  width: string
  // 最小宽度
  minWidth: string
  //最大宽度
  maxWidth: string
  //内容
  temp?: string
  // 表头名
  label?: string
  // 特殊类型
  interactionType?: string
  // 宽度类型
  widthType?: string
  // 是否显示tooltip
  tooltip?: boolean
  // 是否需要验证数据是否为空
  verify?: boolean
  // 单选对应字段
  selectProp?: string
  // 自定义表头名
  customLabel?: string
}

// 根据allTableHeaderList的数据中的label字段，生成表头名的数据类型
export type AllTableHeaderListType =
  typeof allTableHeaderList[number]['customLabel']

// 料单 固定表头
const headPropList: IPropList[] = [
  {
    prop: 'select',
    selectProp: 'isSelected',
    headSlotName: 'headSelect',
    label: 'common.select',
    widthType: 'width',
    width: '64px',
    minWidth: '64px',
    maxWidth: '150px',
    temp: '选择',
    customLabel: getLangeKey('选择'),
  },
  {
    prop: 'plankID',
    headSlotName: 'headPlankID',
    label: 'common.plankNo',
    widthType: 'width',
    width: '86px',
    minWidth: '30px',
    maxWidth: '150px',
    temp: '1',
    customLabel: getLangeKey('板号'),
  },
  {
    prop: 'roomName',
    headSlotName: 'headRoomName',
    label: 'common.room',
    interactionType: 'input',
    widthType: 'width',
    width: '80px',
    minWidth: '60px',
    maxWidth: '150px',
    temp: '主卧',
    customLabel: getLangeKey('房间'),
  },
  {
    prop: 'loc',
    headSlotName: 'headLoc',
    label: 'common.loc',
    interactionType: 'input',
    widthType: 'width',
    width: '63px',
    minWidth: '60px',
    maxWidth: '150px',
    temp: '柜A',
    customLabel: getLangeKey('柜体'),
  },

  {
    prop: 'partName',
    headSlotName: 'headPartName',
    label: 'common.plankName',
    interactionType: 'input',
    widthType: 'width',
    width: '159px',
    minWidth: '100px',
    maxWidth: '150px',
    temp: '主卧_柜A_中立板01',
    tooltip: true,
    customLabel: getLangeKey('板件名称'),
  },
  {
    prop: 'matCode',
    headSlotName: 'headMatCode',
    label: 'common.matCode',
    interactionType: 'input',
    widthType: 'width',
    width: '110px',
    minWidth: '60px',
    maxWidth: '150px',
    temp: '多层实木',
    tooltip: true,
    verify: true,
    customLabel: getLangeKey('材质'),
  },
  {
    prop: 'is_high_gloss_plank',
    headSlotName: 'headHighPlank',
    label: 'common.heighGlossPlank',
    interactionType: 'select',
    widthType: 'width',
    width: '110px',
    minWidth: '60px',
    maxWidth: '150px',
    temp: '高光板',
    tooltip: true,
    verify: true,
    customLabel: getLangeKey('高光板'),
  },
  {
    prop: 'texture',
    headSlotName: 'headTexture',
    label: 'common.color',
    interactionType: 'input',
    widthType: 'width',
    width: '100px',
    minWidth: '60px',
    maxWidth: '150px',
    temp: 'T01',
    tooltip: true,
    verify: true,
    customLabel: getLangeKey('颜色'),
  },
  {
    prop: 'thick',
    headSlotName: 'headThick',
    label: 'common.thick',
    interactionType: 'input',
    widthType: 'width',
    width: '70px',
    temp: '18',
    minWidth: '60px',
    maxWidth: '150px',
    verify: true,
    customLabel: getLangeKey('厚度'),
  },
  {
    prop: 'specHeight',
    headSlotName: 'headSpecHeight',
    label: 'common.finishedHeight',
    interactionType: 'input',
    widthType: 'width',
    temp: '2440',
    width: '106px',
    minWidth: '60px',
    maxWidth: '150px',
    verify: true,
    customLabel: getLangeKey('成品长度'),
  },
  {
    prop: 'specWidth',
    headSlotName: 'headSpecWidth',
    label: 'common.finishedWidth',
    interactionType: 'input',
    widthType: 'width',
    width: '106px',
    temp: '1220',
    minWidth: '60px',
    maxWidth: '150px',
    verify: true,
    customLabel: getLangeKey('成品宽度'),
  },
  {
    prop: 'amount',
    headSlotName: 'headAmount',
    label: 'common.count',
    interactionType: 'input',
    widthType: 'width',
    width: '70px',
    temp: '1',
    minWidth: '30px',
    maxWidth: '150px',
    verify: true,
    customLabel: getLangeKey('数量'),
  },
  {
    prop: 'texDir',
    headSlotName: 'headTexDir',
    label: 'common.texture',
    widthType: 'width',
    width: '116px',
    temp: '竖纹',
    minWidth: '60px',
    maxWidth: '150px',
    customLabel: getLangeKey('纹理'),
  },
  {
    prop: 'hsInfo',
    headSlotName: 'headHsInfo',
    label: 'common.holeSlotsStastic',
    widthType: 'width',
    width: '126px',
    temp: '1孔1槽',
    minWidth: '110px',
    maxWidth: '150px',
    customLabel: getLangeKey('孔槽数量'),
  },
  {
    prop: 'frontEdge',
    headSlotName: 'headFrontEdge',
    label: 'common.edge.front',
    interactionType: 'input',
    widthType: 'width',
    width: '70px',
    minWidth: '30px',
    temp: '0',
    maxWidth: '150px',
    customLabel: getLangeKey('前封边'),
  },
  {
    prop: 'backEdge',
    headSlotName: 'headBackEdge',
    label: 'common.edge.back',
    interactionType: 'input',
    widthType: 'width',
    width: '70px',
    temp: '0',
    maxWidth: '150px',
    minWidth: '30px',
    customLabel: getLangeKey('后封边'),
  },
  {
    prop: 'leftEdge',
    headSlotName: 'headLeftEdge',
    label: 'common.edge.left',
    interactionType: 'input',
    widthType: 'width',
    temp: '0',
    width: '70px',
    minWidth: '30px',
    maxWidth: '150px',
    customLabel: getLangeKey('左封边'),
  },
  {
    prop: 'rightEdge',
    headSlotName: 'headRightEdge',
    label: 'common.edge.right',
    interactionType: 'input',
    widthType: 'width',
    width: '70px',
    minWidth: '30px',
    temp: '0',
    maxWidth: '150px',
    customLabel: getLangeKey('右封边'),
  },
  {
    prop: 'specialShape',
    headSlotName: 'headSpecialShape',
    label: 'common.isSpecial',
    widthType: 'width',
    width: '85px',
    temp: '异形',
    minWidth: '85px',
    maxWidth: '150px',
    customLabel: getLangeKey('异形'),
  },
  {
    prop: 'type',
    headSlotName: 'headType',
    label: 'common.isDoorPlank',
    widthType: 'width',
    width: '180px',
    minWidth: '150px',
    temp: '门板',
    maxWidth: '150px',
    customLabel: getLangeKey('门板'),
  },
  // partNameWithoutRoomCabinet、finishedArea 不进默认表头，
  // 仅作为「自定义表头」可选项保留在 allTableHeaderList 中，避免给老用户默认追加新列
]

// 生产文件管理
const productionFillManageList: IPropList[] = [
  {
    prop: 'select',
    selectProp: 'isSelect',
    headSlotName: 'headSelect',
    label: 'common.select',
    widthType: 'width',
    width: '64px',
    minWidth: '64px',
    maxWidth: '150px',
  },
  {
    prop: 'index',
    headSlotName: 'headIndex',
    label: 'common.inde',
    widthType: 'width',
    width: '80px',
    minWidth: '64px',
    maxWidth: '150px',
  },
  {
    prop: 'address',
    headSlotName: 'headAddress',
    label: 'common.orderAddress',
    widthType: 'width',
    width: '340px',
    minWidth: '120px',
    maxWidth: '150px',
    tooltip: true,
  },
  {
    prop: 'order_id',
    headSlotName: 'headOrderId',
    label: 'common.orderNo',
    widthType: 'width',
    width: '180px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
  },
  {
    prop: 'product_line',
    headSlotName: 'headProductLine',
    label: 'common.productionLine',
    widthType: 'width',
    width: '280px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
  },
  {
    prop: 'create_time',
    headSlotName: 'headSaveTime',
    label: 'taskPage.record.saveDate',
    widthType: 'width',
    width: '200px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
  },
  {
    prop: 'operate',
    headSlotName: 'headOperate',
    label: 'common.operation',
    widthType: 'width',
    width: '350px',
    minWidth: '300px',
    maxWidth: '150px',
  },
]
// 补件
const bujianList: IPropList[] = [
  {
    prop: 'plankID',
    headSlotName: 'headPlankID',
    label: 'common.plankNo',
    widthType: 'width',
    width: '80px',
    minWidth: '44px',
    maxWidth: '150px',
  },
  {
    prop: 'matCode',
    headSlotName: 'headMatCode',
    label: 'common.matCode',
    widthType: 'width',
    width: '280px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
  },
  {
    prop: 'texture',
    headSlotName: 'headTexture',
    label: 'common.color',
    widthType: 'width',
    width: '180px',
    minWidth: '80px',
    maxWidth: '150px',
    tooltip: true,
  },
  {
    prop: 'oSize',
    headSlotName: 'headOSize',
    label: 'materialPage.plankSize',
    widthType: 'width',
    width: '280px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
  },
  {
    prop: 'plankNum',
    headSlotName: 'headPlankNum',
    label: 'common.plankNum',
    widthType: 'width',
    width: '280px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
  },
  {
    prop: 'operate',
    headSlotName: 'headOperate',
    label: 'common.operation',
    widthType: 'width',
    width: '350px',
    maxWidth: '150px',
    minWidth: '100px',
  },
]
// 补件仓库
const bujianStoreList: IPropList[] = [
  {
    prop: 'select',
    selectProp: 'isSelect',
    headSlotName: 'headSelect',
    label: 'common.select',
    widthType: 'width',
    width: '64px',
    minWidth: '64px',
    maxWidth: '150px',
  },
  {
    prop: 'plankID',
    headSlotName: 'headPlankId',
    label: 'common.plankNo',
    widthType: 'width',
    width: '100px',
    minWidth: '44px',
    maxWidth: '150px',
  },
  {
    prop: 'matCode',
    headSlotName: 'headMatCode',
    label: 'common.matCode',
    widthType: 'width',
    width: '200px',
    minWidth: '100px',
    tooltip: true,
    maxWidth: '150px',
  },
  {
    prop: 'texture',
    headSlotName: 'headTexture',
    label: 'common.color',
    widthType: 'width',
    width: '180px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
  },
  {
    prop: 'sizeStr',
    headSlotName: 'headOSize',
    label: 'materialPage.plankSize2',
    widthType: 'width',
    maxWidth: '150px',
    width: '180px',
    minWidth: '100px',
    tooltip: true,
  },
  {
    prop: 'plankNum',
    headSlotName: 'headPlankNum',
    label: 'common.plankNum',
    widthType: 'width',
    maxWidth: '150px',
    width: '180px',
    minWidth: '100px',
    tooltip: true,
  },
  {
    prop: 'create_time',
    headSlotName: 'headSaveTime',
    label: 'taskPage.record.saveDate',
    widthType: 'width',
    maxWidth: '150px',
    width: '200px',
    minWidth: '100px',
    tooltip: true,
  },
  {
    prop: 'operate',
    headSlotName: 'headOperate',
    label: 'common.operation',
    widthType: 'width',
    width: '350px',
    maxWidth: '150px',
    minWidth: '200px',
  },
]

//所有表头的数据
const allTableHeaderList = [
  {
    prop: 'select',
    selectProp: 'isSelected',
    headSlotName: 'headSelect',
    label: getLangeKey('选择'),
    widthType: 'width',
    width: '64px',
    minWidth: '64px',
    maxWidth: '150px',
    temp: '选择',
    sort: 0,
    customLabel: getLangeKey('选择'),
  },
  {
    prop: 'loc',
    headSlotName: 'headLoc',
    label: getLangeKey('柜体'),
    interactionType: 'input',
    widthType: 'width',
    width: '63px',
    minWidth: '30px',
    maxWidth: '150px',
    temp: '柜A',
    sort: 1,
    customLabel: getLangeKey('柜体'),
  },
  {
    prop: 'customer_name',
    headSlotName: 'headCustomerName',
    label: getLangeKey('客户'),
    interactionType: 'input',
    widthType: 'width',
    width: '63px',
    minWidth: '30px',
    maxWidth: '150px',
    temp: '张总',
    sort: 2,
    customLabel: getLangeKey('客户'),
  },
  {
    prop: 'frontEdge',
    headSlotName: 'headFrontEdge',
    label: getLangeKey('前封边'),
    interactionType: 'input',
    widthType: 'width',
    width: '70px',
    minWidth: '30px',
    maxWidth: '150px',
    temp: '0',
    sort: 3,
    customLabel: getLangeKey('前封边'),
  },
  {
    prop: 'roomName',
    headSlotName: 'headRoomName',
    label: getLangeKey('房间'),
    interactionType: 'input',
    widthType: 'width',
    width: '80px',
    minWidth: '30px',
    maxWidth: '150px',
    temp: '主卧',
    sort: 4,
    customLabel: getLangeKey('房间'),
  },
  {
    prop: 'plankID',
    headSlotName: 'headPlankID',
    label: getLangeKey('板号'),
    widthType: 'width',
    width: '86px',
    minWidth: '30px',
    maxWidth: '150px',
    temp: '1',
    sort: 5,
    customLabel: getLangeKey('板号'),
  },
  {
    prop: 'partName',
    headSlotName: 'headPartName',
    label: getLangeKey('板件名称'),
    interactionType: 'input',
    widthType: 'width',
    width: '159px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
    temp: '主卧_柜A_中立板01',
    sort: 6,
    customLabel: getLangeKey('板件名称'),
  },
  {
    prop: 'hsInfo',
    headSlotName: 'headHsInfo',
    label: getLangeKey('孔槽数量'),
    widthType: 'width',
    width: '126px',
    minWidth: '110px',
    maxWidth: '150px',
    temp: '1孔1槽',
    sort: 7,
    customLabel: getLangeKey('孔槽数量'),
  },
  {
    prop: 'matCode',
    headSlotName: 'headMatCode',
    label: getLangeKey('材质'),
    interactionType: 'input',
    widthType: 'width',
    width: '110px',
    minWidth: '60px',
    maxWidth: '150px',
    tooltip: true,
    verify: true,
    temp: '多层实木',
    require: true,
    sort: 8,
    customLabel: getLangeKey('材质'),
  },
  {
    prop: 'orderNo',
    headSlotName: 'headOrderNo',
    label: getLangeKey('订单号'),
    interactionType: 'input',
    widthType: 'width',
    width: '80px',
    minWidth: '30px',
    maxWidth: '150px',
    temp: '211006-35',
    sort: 9,
    customLabel: getLangeKey('订单号'),
  },
  {
    prop: 'plank_remarks',
    headSlotName: 'headPlankRemarks',
    interactionType: 'input',
    label: getLangeKey('板件备注'),
    widthType: 'width',
    width: '200px',
    minWidth: '180px',
    maxWidth: '230px',
    tooltip: true,
    temp: '板件备注',
    customLabel: getLangeKey('板件备注'),
  },
  {
    prop: 'remark',
    headSlotName: 'headRemark',
    interactionType: 'input',
    label: getLangeKey('房间备注'),
    widthType: 'width',
    width: '200px',
    minWidth: '180px',
    maxWidth: '230px',
    tooltip: true,
    temp: '房间备注',
    customLabel: getLangeKey('房间备注'),
  },
  {
    prop: 'openDir',
    headSlotName: 'headOpenDir',
    interactionType: 'input',
    label: getLangeKey('开门方向'),
    widthType: 'width',
    width: '110px',
    minWidth: '60px',
    maxWidth: '200px',
    tooltip: true,
    temp: '开门方向',
    customLabel: getLangeKey('开门方向'),
  },
  {
    prop: 'backEdge',
    headSlotName: 'headBackEdge',
    label: getLangeKey('后封边'),
    interactionType: 'input',
    widthType: 'width',
    width: '70px',
    minWidth: '30px',
    maxWidth: '150px',
    temp: '0',
    sort: 10,
    customLabel: getLangeKey('后封边'),
  },
  {
    prop: 'texture',
    headSlotName: 'headTexture',
    label: getLangeKey('颜色'),
    interactionType: 'input',
    widthType: 'width',
    width: '100px',
    minWidth: '60px',
    maxWidth: '150px',
    tooltip: true,
    verify: true,
    temp: 'T01',
    require: true,
    sort: 11,
    customLabel: getLangeKey('颜色'),
  },
  {
    prop: 'address',
    headSlotName: 'headAddress',
    label: getLangeKey('项目地址'),
    interactionType: 'input',
    widthType: 'width',
    width: '120px',
    minWidth: '100px',
    maxWidth: '150px',
    temp: '订单一',
    sort: 12,
    customLabel: getLangeKey('项目地址'),
  },
  {
    prop: 'leftEdge',
    headSlotName: 'headLeftEdge',
    label: getLangeKey('左封边'),
    interactionType: 'input',
    widthType: 'width',
    width: '70px',
    minWidth: '30px',
    maxWidth: '150px',
    temp: '0',
    sort: 13,
    customLabel: getLangeKey('左封边'),
  },
  {
    prop: 'thick',
    headSlotName: 'headThick',
    label: getLangeKey('厚度'),
    interactionType: 'input',
    widthType: 'width',
    width: '78px',
    minWidth: '30px',
    maxWidth: '150px',
    verify: true,
    temp: '18',
    require: true,
    sort: 14,
    customLabel: getLangeKey('厚度'),
  },
  {
    prop: 'plankNum',
    headSlotName: 'headPlankNum',
    label: getLangeKey('板件条码'),
    // interactionType: 'input',
    widthType: 'width',
    width: '120px',
    minWidth: '100px',
    maxWidth: '150px',
    temp: '6100200300400',
    sort: 15,
    customLabel: getLangeKey('板件条码'),
  },
  {
    prop: 'type',
    headSlotName: 'headType',
    label: getLangeKey('门板'),
    widthType: 'width',
    width: '63px',
    minWidth: '30px',
    maxWidth: '150px',
    temp: '门板',
    sort: 16,
    customLabel: getLangeKey('门板'),
  },
  {
    prop: 'rightEdge',
    headSlotName: 'headRightEdge',
    label: getLangeKey('右封边'),
    interactionType: 'input',
    widthType: 'width',
    width: '70px',
    minWidth: '30px',
    maxWidth: '150px',
    temp: '0',
    sort: 17,
    customLabel: getLangeKey('右封边'),
  },
  {
    prop: 'specialShape',
    headSlotName: 'headSpecialShape',
    label: getLangeKey('异形'),
    widthType: 'width',
    width: '63px',
    minWidth: '30px',
    maxWidth: '150px',
    temp: '异形',
    sort: 18,
    customLabel: getLangeKey('异形'),
  },
  {
    prop: 'specHeight',
    headSlotName: 'headSpecHeight',
    label: getLangeKey('成品长度'),
    interactionType: 'input',
    widthType: 'width',
    width: '106px',
    minWidth: '60px',
    maxWidth: '150px',
    verify: true,
    temp: '2440',
    require: true,
    sort: 19,
    customLabel: getLangeKey('成品长度'),
  },
  {
    prop: 'specWidth',
    headSlotName: 'headSpecWidth',
    label: getLangeKey('成品宽度'),
    interactionType: 'input',
    widthType: 'width',
    width: '126px',
    minWidth: '60px',
    maxWidth: '150px',
    verify: true,
    temp: '1220',
    require: true,
    sort: 20,
    customLabel: getLangeKey('成品宽度'),
  },
  {
    prop: 'amount',
    headSlotName: 'headAmount',
    label: getLangeKey('数量'),
    interactionType: 'input',
    widthType: 'width',
    width: '78px',
    minWidth: '30px',
    maxWidth: '150px',
    verify: true,
    temp: '1',
    require: true,
    sort: 21,
    customLabel: getLangeKey('数量'),
  },
  {
    prop: 'texDir',
    headSlotName: 'headTexDir',
    label: getLangeKey('纹理'),
    widthType: 'width',
    width: '126px',
    minWidth: '60px',
    maxWidth: '150px',
    temp: '竖纹',
    require: true,
    sort: 22,
    customLabel: getLangeKey('纹理'),
  },
  {
    prop: 'is_high_gloss_plank',
    headSlotName: 'headIsHighGlossPlank',
    label: getLangeKey('高光板'),
    widthType: 'width',
    width: '126px',
    minWidth: '60px',
    maxWidth: '150px',
    temp: false,
    require: true,
    sort: 23,
    customLabel: getLangeKey('高光板'),
  },
  // 在表头数据标签池里面新增订单备注信息
  {
    prop: 'order_remark',
    headSlotName: 'headOrderRemark',
    interactionType: 'input',
    label: getLangeKey('订单备注'),
    widthType: 'width',
    width: '200px',
    minWidth: '180px',
    maxWidth: '230px',
    tooltip: true,
    temp: '订单备注',
    customLabel: getLangeKey('订单备注'),
  },
  {
    prop: 'process_label',
    headSlotName: 'headProcessLabel',
    // interactionType: 'input',
    label: getLangeKey('特殊工艺'),
    widthType: 'width',
    width: '200px',
    minWidth: '180px',
    maxWidth: '230px',
    tooltip: true,
    temp: '特殊工艺',
    customLabel: getLangeKey('特殊工艺'),
  },
  {
    prop: 'partNameWithoutRoomCabinet',
    headSlotName: 'headPartNameWithoutRoomCabinet',
    label: getLangeKey('板件名称(不含房间柜体)'),
    interactionType: 'input',
    widthType: 'width',
    width: '159px',
    minWidth: '100px',
    maxWidth: '150px',
    tooltip: true,
    temp: '中立板01',
    customLabel: getLangeKey('板件名称(不含房间柜体)'),
  },
  {
    prop: 'finishedArea',
    headSlotName: 'headFinishedArea',
    label: getLangeKey('成品面积(㎡)'),
    widthType: 'width',
    width: '106px',
    minWidth: '60px',
    maxWidth: '150px',
    temp: '2.98',
    customLabel: getLangeKey('成品面积(㎡)'),
  },
  {
    prop: 'textureGrainInfo',
    headSlotName: 'headTextureGrainInfo',
    label: getLangeKey('对纹组'),
    widthType: 'width',
    width: '120px',
    minWidth: '100px',
    maxWidth: '150px',
    sort: true,
    tooltip: true,
    temp: '对纹组一',
    customLabel: getLangeKey('对纹组'),
  },
] as const
export {
  headPropList,
  productionFillManageList,
  bujianList,
  bujianStoreList,
  allTableHeaderList,
  IPropList,
}
